import axios from "axios";
import { isEmail } from "validator";
import { ValidationError, ApiError } from "./errors";
import mockAPI from "./api-mock";

const endpointURL = process.env.REACT_APP_API_URL || window.location.origin;

console.log(`Endpoint API url: ${endpointURL}`);

if (process.env.REACT_APP_MOCK_API == 1) {
  mockAPI(axios);
} else {
  console.log(`Using live Stripe API`);
}

const checkoutClient = axios.create({
  baseURL: `${endpointURL}/api/checkout/v1`
});

const licenseClient = axios.create({
  baseURL: `${endpointURL}/api/license/v1`
});

export const getPrices = async (promotion = "") => {
  const { data } = await checkoutClient.post(`/get_prices`, {
    promotion
  });

  if (!data || data.error) {
    throw new ApiError(data.error);
  }

  return data;
}

export const validateEmail = async (customer, email) => {
  if (!isEmail(email)) {
    throw new ValidationError("Invalid email address");
  }

  const { data } = await checkoutClient.post("/validate_email", {
    customer,
    email
  });

  if (!data || data.error_message) {
    throw new ApiError(data.error_message);
  }

  return data;
}

export const validateOTP = async (customer, code) => {
  const { data } = await checkoutClient.post("/validate_otp", {
    customer,
    code
  });

  if (!data || data.error_message) {
    throw new ApiError(data.error_message);
  }

  return data;
}

export const createSubscription = async (customer, firstName, lastName, company, seats, sku, license, promotion, vpnSeats) => {
  const { data } = await checkoutClient.post("/create_subscription", {
    customer,
    firstName,
    lastName,
    company,
    seats,
    sku,
    license,
    promotion,
    vpnSeats
  });

  if (!data || data.error) {
    throw new Error(`Cannot update subscription. ${data.error}`);
  }

  return {
    secret: data.secret,
    subscriptionId: data.subscription_id
  };
}

export const updateSubscription = async (customer, subscriptionId, firstName, lastName, company, seats, sku, license, promotion) => {
  const { data } = await checkoutClient.post("/update_subscription", {
    customer,
    subscriptionId,
    firstName,
    lastName,
    company,
    seats,
    sku,
    license,
    promotion
  });

  if (!data || data.error) {
    throw new Error(`Cannot update subscription. ${data.error}`);
  }

  return {
    secret: data.secret,
    subscriptionId: data.subscription_id
  };
}

export const getLicenseActivationKey = async (customerId, paymentIntentId) => {
  const { data } = await checkoutClient.post("/get_activation_key", {
    id: customerId,
    paymentIntentId
  });

  if (!data || data.error) {
    throw new Error(`Cannot get license activation key. ${data.error}`);
  }

  return data.key;
}

export const activateLicense = async (installationId, activationKey) => {
  try {
    const { data } = await licenseClient.post("/activate", {
      installation_id: installationId,
      activation_key: activationKey
    });

    return data.license_key;
  } catch (e) {
    throw new Error(`Cannot activate license. ${e.response.data.error_message}`);
  }
}